import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=0558ad89&scoped=true&"
import script from "./bind.vue?vue&type=script&lang=ts&"
export * from "./bind.vue?vue&type=script&lang=ts&"
import style0 from "./bind.vue?vue&type=style&index=0&id=0558ad89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0558ad89",
  null
  
)

export default component.exports